// Favourite tools, kept in this browser only (specs/00-standards.md §11). Ids are tool ids (the path without "/"),
// the same ids the search index and "recent tools" use. Every storage access goes through safeStorage, which never throws.
import { safeStorage } from '../lib/safeStorage';

const KEY = 'dsk:favorites';
const MAX_FAVORITES = 100;
export const FAVORITES_UPDATED_EVENT = 'devstackkit:favorites-updated';

export function getFavorites(): string[] {
  try {
    const parsed = JSON.parse(safeStorage.get(KEY) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string').slice(0, MAX_FAVORITES) : [];
  } catch {
    return [];
  }
}

export function isFavorite(toolId: string): boolean {
  return getFavorites().includes(toolId);
}

/** Adds or removes a tool. New favourites go to the front. Returns the new state (false also when storage is blocked). */
export function toggleFavorite(toolId: string): boolean {
  if (!toolId) return false;
  const current = getFavorites();
  const was = current.includes(toolId);
  const next = was ? current.filter((id) => id !== toolId) : [toolId, ...current].slice(0, MAX_FAVORITES);
  const saved = safeStorage.set(KEY, JSON.stringify(next));
  if (saved && typeof window !== 'undefined') window.dispatchEvent(new Event(FAVORITES_UPDATED_EVENT));
  return saved ? !was : was;
}
